<template>
  <div class="livestats-table">
    <div  v-if="Object.keys(liveStats()).length">
      <h4 class="muted">Overview for {{ selectedPeriod }}</h4>
      <hr/>
      <streaming-overview-item
      :statLabel="'Total streams'"
      :statValue="formatNumber(avgData.streaming.totalConnections)"
      />
      <streaming-overview-item
      :statLabel="'Unique listeners'"
      :statValue="formatNumber(avgData.streaming.uniqueListeners)"
      />
      <streaming-overview-item
      :statLabel="'Average duration'"
      :statValue="formatTime(avgData.streaming.averageDuration)"
      />
      <streaming-overview-item
      :statLabel="'Average concurrent streams'"
      :statValue="avgData.streaming.averageConnections.toFixed()"
      />
      <streaming-overview-item
      :statLabel="'Maximum concurrent streams'"
      :statValue="formatNumber(avgData.streaming.maxStreams)"
      />
      <streaming-overview-item
      class="label-success"
      :statLabel="'Live streams now'"
      :statValue="formatNumber(liveStats().live_streams)"
      />
    </div>
    <div v-else>
      <div class="loading" v-loading="true" style="width:100%">
      </div>
    </div>
  </div>
</template>

<script>
 import StreamingOverviewItem from './StreamingOverviewItem';

export default {
   name: 'StreamingOverviewTable',

   props: {
     avgData: {
       type: Object,
       default: () => ({
         streaming: [],
         listeners: [],
       }),
     },
     selectedPeriod: {
       type: String,
       default: '',
     },
   },
   components: {
     StreamingOverviewItem,
   },
   methods: {
     formatTime(time) {
       const toMins = time / 60;
       if (toMins > 59) {
         const toHour = toMins / 60;
         const remMins = toMins % 60;
         return `${toHour.toFixed()}h ${remMins.toFixed()}m`;
       }
       return `0h ${toMins.toFixed()}m`;
     },
     formatNumber(num) {
       return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
     },
     liveStats() {
       return this.$store.state.analytics.liveStreamingStates;
     },
   },
};
</script>


<style lang="scss" scoped>
.loading {
  margin: 0 auto;
  padding: 20px;
}

</style>



// WEBPACK FOOTER //
// StreamingOverviewTable.vue?699b35a6